import type { GAEventName } from './ga.types';

// GTM's own timeout for eventCallback; we use the same value as a fallback for when GTM is blocked or not loaded
const EVENT_CALLBACK_TIMEOUT_MS = 800;

type DataLayerWindow = Window & { dataLayer?: Record<string, unknown>[] };

const getDataLayer = () => {
  const dataLayerWindow = window as DataLayerWindow;
  dataLayerWindow.dataLayer = dataLayerWindow.dataLayer || [];
  return dataLayerWindow.dataLayer;
};

/**
 * Pushes an event to the Google Tag Manager data layer.
 * Pass `onSent` when the page is about to navigate away, so the tags get a chance to fire first.
 */
export const sendGAEvent = (eventName: GAEventName, parameters = {}, onSent?: () => void) => {
  if (!onSent) {
    getDataLayer().push({ event: eventName, ...parameters });
    return;
  }

  let isDone = false;
  const done = () => {
    if (!isDone) {
      isDone = true;
      onSent();
    }
  };

  getDataLayer().push({
    event: eventName,
    ...parameters,
    eventCallback: done,
    eventTimeout: EVENT_CALLBACK_TIMEOUT_MS,
  });

  // GTM never calls eventCallback when it is blocked or not loaded
  window.setTimeout(done, EVENT_CALLBACK_TIMEOUT_MS);
};
